import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2115fc99"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TlmContainer: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmContainer.vue').default,TlmSection: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmSection.vue').default})
